import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Shield, Info, HelpCircle, ClipboardList, Phone, BarChart3, Video } from 'lucide-react';

const cards = [
  { path: '/admin/cms/basic-quiz', label: 'Basic Quiz', icon: ClipboardList, desc: 'Edit 5 basic quiz questions (public page, no login required)' },
  { path: '/admin/cms/terms', label: 'Terms & Conditions', icon: FileText, desc: 'Edit terms and conditions content' },
  { path: '/admin/cms/privacy', label: 'Privacy Policy', icon: Shield, desc: 'Edit privacy policy sections' },
  { path: '/admin/cms/non-refund', label: 'Non Refund Policy', icon: FileText, desc: 'Edit non-refund policy content' },
  { path: '/admin/cms/educational-disclaimer', label: 'Educational Disclaimer', icon: Shield, desc: 'Edit educational disclaimer content' },
  { path: '/admin/cms/about', label: 'About Us', icon: Info, desc: 'Edit about us page content' },
  { path: '/admin/cms/faq', label: 'FAQ', icon: HelpCircle, desc: 'Edit frequently asked questions (homepage section)' },
  { path: '/admin/cms/contact', label: 'Contact Info', icon: Phone, desc: 'Edit contact numbers, email, address, and social links' },
  { path: '/admin/cms/platform-stats', label: 'Platform States', icon: BarChart3, desc: 'Edit stats shown on Landing (Active Traders, Courses, volume, brokers, etc.)' },
  { path: '/admin/cms/why-choose-us', label: 'Why Choose Us', icon: Info, desc: 'Edit the "Why Market Mavericks?" section with title, points and image.' },
];

const AdminCMSIndex = () => {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800">CMS Pages</h1>
        <p className="text-gray-600 text-sm mt-1">Manage Basic Quiz, Terms, Privacy Policy, About Us, and FAQ. Changes appear on the public site.</p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {cards.map(({ path, label, icon: Icon, desc }) => (
          <Link
            key={path}
            to={path}
            className="flex items-start gap-4 p-6 rounded-xl border-2 border-gray-200 bg-white hover:border-primary-300 hover:bg-primary-50/50 transition-colors"
          >
            <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
              <Icon className="w-6 h-6 text-primary-600" />
            </div>
            <div className="min-w-0">
              <h2 className="font-semibold text-gray-800">{label}</h2>
              <p className="text-sm text-gray-500 mt-0.5">{desc}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AdminCMSIndex;
